/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneCoverBox from 'base/components/standalone/CoverBox';

export const DynamicStandaloneCoverBox = StandaloneCoverBox;
export type DynamicStandaloneCoverBoxProps = PropsFromComponent<typeof StandaloneCoverBox>;

export const DynamicStandaloneCoverBoxWith = (extras: DynamicStandaloneExtras): typeof StandaloneCoverBox => {
    return function DynamicStandaloneCoverBox(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'CoverBox');
        return <StandaloneCoverBox {...mergeProps({ options: { theme } }, props)} />;
    }
}